import { Action } from '@ngrx/store';

export const CommentsResourcesActionTypes = {
  GET_COMMENTS_RESOURCES: '@bidi/common-components CommentsResources GET_COMMENTS_RESOURCES',
  GET_COMMENTS_RESOURCES_SUCCESS: '@bidi/common-components CommentsResources GET_COMMENTS_RESOURCES_SUCCESS',
  GET_COMMENTS_RESOURCES_FAILURE: '@bidi/common-components CommentsResources GET_COMMENTS_RESOURCES_FAILURE',
  SET_COMMENTS_RESOURCES_SAVED: '@bidi/common-components CommentsResources SET_COMMENTS_RESOURCES_SAVED',
  SET_COMMENTS_RESOURCES_SAVED_SUCCESS: '@bidi/common-components CommentsResources SET_COMMENTS_RESOURCES_SAVED_SUCCESS',
  LOADING_COMMENTS: '@bidi/common-components CommentsResources LOADING_COMMENTS',
};


export class GetCommentsResources implements Action {
  readonly type = CommentsResourcesActionTypes.GET_COMMENTS_RESOURCES;

  constructor (public payload: any) {
  }
}

export class GetCommentsResourcesSuccess implements Action {
  readonly type = CommentsResourcesActionTypes.GET_COMMENTS_RESOURCES_SUCCESS;

  constructor (public payload: any) {
  }
}

export class GetCommentsResourcesFailure implements Action {
  readonly type = CommentsResourcesActionTypes.GET_COMMENTS_RESOURCES_FAILURE;

  constructor (public payload: any) {
  }
}

export class SetCommentsResourcesSaved implements Action {
  readonly type = CommentsResourcesActionTypes.SET_COMMENTS_RESOURCES_SAVED;

  constructor (public payload: any) {
  }
}

export class SetCommentsResourcesSavedSuccess implements Action {
  readonly type = CommentsResourcesActionTypes.SET_COMMENTS_RESOURCES_SAVED_SUCCESS;

  constructor (public payload: any) {
  }
}

export class LoadingComments implements Action {
  readonly type = CommentsResourcesActionTypes.LOADING_COMMENTS;

  constructor (public payload: any) {
  }
}
